module.exports = __webpack_public_path__ + "img/exchange-2.2b416c7a.png";